<template>
	<b-modal
		hide-footer
		ref="modal-view"
		size="xl"
		:title="
			modelId > 0
				? 'Edición de cierre de ventas'
				: 'Nuevo cierre de ventas'
		"
	>
		<b-overlay :show="loading" no-wrap></b-overlay>
		<b-card no-body>
			<b-tabs no-fade pills card small vertical nav-class="nav-style">
				<b-tab title="General" active>
					<b-form @submit="onSubmit">
						<b-form-row>
							<b-form-group
								:disabled="unableEdit"
								class="col-lg-6"
								label="Descripción"
							>
								<b-form-input
									class="form-control"
									type="text"
									size="sm"
									v-model="modelInfo.description"
									required
								/>
							</b-form-group>

							<b-form-group
								:disabled="unableEdit"
								class="col-lg-6"
								label="Fechas"
							>
								<DatePicker
									v-model="range"
									:masks="masks"
									:columns="2"
									is-range
									:disabled="unableEdit"
									:popover="{
										visibility: 'click',
										placement: 'left'
									}"
									:select-attribute="attribute"
									:drag-attribute="attribute"
								>
									<template
										v-slot="{
											inputValue,
											inputEvents,
											isDragging
										}"
									>
										<div
											class="d-flex justify-content-between w-100"
										>
											<div class="relative flex-grow">
												<input
													class="form-control flex-grow border rounded w-full"
													:class="
														isDragging
															? 'text-gray-600'
															: 'text-gray-900'
													"
													:value="inputValue.start"
													v-on="inputEvents.start"
													readonly
												/>
											</div>

											<svg
												class="arrow"
												fill="none"
												viewBox="0 0 24 24"
												stroke="currentColor"
											>
												<path
													stroke-linecap="round"
													stroke-linejoin="round"
													stroke-width="2"
													d="M14 5l7 7m0 0l-7 7m7-7H3"
												/>
											</svg>

											<div class="relative flex-grow">
												<input
													class="form-control flex-grow border rounded w-full"
													:class="
														isDragging
															? 'text-gray-600'
															: 'text-gray-900'
													"
													:value="inputValue.end"
													v-on="inputEvents.end"
													readonly
												/>
											</div>
										</div>
									</template>
								</DatePicker>
							</b-form-group>

							<b-form-group
								class="col-lg-6"
								label="Plan tarifario"
							>
								<multiselect
									:disabled="unableEdit"
									@select="selectRatePlan"
									:options="ratePlansOpts"
									v-model="ratePlansSelected"
									:multiple="false"
									:show-labels="false"
									label="text"
									track-by="value"
								/>
							</b-form-group>

							<b-form-group
								class="col-lg-6"
								label="Tipos de servicio"
							>
								<multiselect
									:disabled="unableEdit"
									:options="serviceTypesOpts"
									v-model="serviceTypesSelected"
									group-label="group"
									group-values="options"
									group-select
									:multiple="true"
									:taggable="true"
									label="text"
									track-by="value"
								/>
							</b-form-group>

							<!-- <b-form-group v-if="childrenRatePlan.length" class="col-lg-12">
                                <b-card class="col-lg-12">
                                    <b-card-text>
                                        <small>
                                            <p clasS="text-danger">Las siguientes tarifas tambien serán afectadas con el cierre de ventas: </p>
                                            <ul id="childrenRatePlans" class="text-muted">
                                                <li v-for="(child, index) in childrenRatePlan" :key="index">{{ child }}</li>
                                            </ul>
                                        </small>
                                    </b-card-text>
                                </b-card>
                            </b-form-group> -->

							<b-form-group
								v-if="childrenRatePlan.length"
								class="col-lg-12"
							>
								<b-button
									:disabled="unableEdit"
									b-button
									v-b-toggle.collapse
									class="m-1 btn btn-secondary"
								>
									Tarifas hijas ({{
										childrenRatePlan.length
									}})
								</b-button>
								<b-collapse v-model="visible" id="collapse">
									<b-card class="col-lg-12">
										<b-card-text>
											<small>
												<p clasS="text-danger">
													Las siguientes tarifas
													tambien serán afectadas con
													el cierre de ventas:
												</p>
												<ul
													id="childrenRatePlans"
													class="text-muted"
												>
													<li
														v-for="(child,
														index) in childrenRatePlan"
														:key="index"
													>
														{{ child }}
													</li>
												</ul>
											</small>
										</b-card-text>
									</b-card>
								</b-collapse>
							</b-form-group>

							<b-form-group
								:disabled="unableEdit"
								class="col-lg-12"
								label="Estado de cierre"
							>
								<b-form-radio-group
									v-model="status"
									name="status"
								>
									<b-form-radio value="active" checked
										>Activo</b-form-radio
									>
									<b-form-radio value="inactive"
										>Inactivo</b-form-radio
									>
								</b-form-radio-group>
							</b-form-group>

							<b-form-group class="col-lg-12">
								<div class="text-center mb-2">
									<p
										class="text-danger"
										v-if="errorForm != null"
										v-html="errorForm"
									></p>
								</div>
							</b-form-group>

							<div class="text-right mt-3">
								<b-button
									:disabled="unableEdit"
									variant="primary"
									type="submit"
									>{{
										modelId > 0 ? "Actualizar" : "Guardar"
									}}</b-button
								>
							</div>
						</b-form-row>
					</b-form>
				</b-tab>
			</b-tabs>
		</b-card>
	</b-modal>
</template>

<script>
import Multiselect from "vue-multiselect";
import DatePicker from "v-calendar/lib/components/date-picker.umd";
// import Utils from "@/Utils/index.js";

export default {
	components: { Multiselect, DatePicker },
	props: {
		unableEdit: Boolean,
		successCallback: {
			type: Function,
			required: false,
			default: () => {}
		}
	},
	data() {
		const defaultModelInfo = {
			id: -1,
			description: "",
			status: "active",
			startDate: "",
			endDate: "",
			ratePlanId: "",
			serviceTypes: ""
		};
		return {
			modelId: -1,
			modelInfo: { ...defaultModelInfo },
			loading: false,
			ratePlans: [],
			ratePlansSelected: [],
			serviceTypes: [],
			serviceTypesSelected: [],
			range: this.setTimeDefault(),
			status: "active",
			childrenRatePlan: [],
			visible: "true",
			masks: {
				input: ["YYYY/MM/DD", "YYYY/MM/DD"]
			},
			attribute: {
				highlight: {
					start: {
						style: { backgroundColor: "#FF3F3F" },
						contentStyle: { color: "#ffffff" }
					},
					base: { style: { backgroundColor: "#FE6363" } },
					end: {
						style: { backgroundColor: "#FF3F3F" },
						contentStyle: { color: "#ffffff" }
					}
				}
			},
			errorForm: null
		};
	},
	computed: {
		ratePlansOpts() {
			return this.ratePlans.map(rp => ({ value: rp.id, text: rp.title }));
		},
		// serviceTypesOpts() {
		//   return this.serviceTypes.map((st) => ({ value: st.id, text: st.name }));
		// },
		serviceTypesOpts() {
			return [
				{
					group: "SELECT ALL",
					options: this.serviceTypes.map(st => ({
						value: st.id,
						text: st.name
					}))
				}
			];
		}
	},
	methods: {
		fetchModel() {
			if (this.modelId > 0) {
				this.loading = true;
				this.$root.api
					.get(`/locks/${this.modelId}`)
					.then(res => {
						this.$emit('update:unableEdit',!this.$hasPermission('stopSale.edit'))
						this.modelInfo = { ...res.data };

						var ratePlan = this.ratePlans.find(
							rt => rt.id == this.modelInfo.ratePlanId
						);
						this.ratePlansSelected = {
							value: ratePlan.id,
							text: ratePlan.title
						};
						this.serviceTypes = ratePlan.services;
						this.serviceTypesSelected = this.modelInfo.serviceTypes.map(
							st => ({ value: st.id, text: st.name })
						);
						this.status = this.modelInfo.status;

						//preselect dates
						let start = new Date(this.modelInfo.startDate);
						let end = new Date(this.modelInfo.endDate);
						this.range = { start, end };

						//child parent rate
						this.childrenRatePlan = [];
						if (ratePlan.childrenRatePlan.length) {
							ratePlan.childrenRatePlan.forEach(element => {
								this.childrenRatePlan.push(
									`${element.id}: ${element.title}`
								);
							});
						}

						if (this.childrenRatePlan.length >= 10) {
							this.visible = false;
						} else {
							this.visible = true;
						}

						this.loading = false;
					})
					.catch(this.$root.handleRequestError);
			} else {
				this.modelInfo = { ...this.defaultModelInfo };
				this.range = this.setTimeDefault();
				this.ratePlansSelected = [];
				this.serviceTypesSelected = [];
				this.serviceTypes = [];
				this.status = "active";
				this.childrenRatePlan = [];
				this.visible = false;
				this.loading = false;
			}
		},
		loadModel(id) {
			//reseteamos el valor de mensaje de error
			this.errorForm = null;
			this.modelId = id;
			this.$refs["modal-view"].show();
			this.fetchModel();
		},
		onSubmit(event) {
			event.preventDefault();

			if (this.$listeners.submit) {
				this.$listeners.submit(event);
				return;
			}

			let rParams = {
				url: this.modelId > 0 ? `/locks/${this.modelId}` : "/locks",
				method: this.modelId > 0 ? "put" : "post"
			};

			if (this.ratePlansSelected.length == 0) {
				this.$root.showAlert("Seleccione un plan tarifario", {
					variant: "warning"
				});
				return false;
			}

			if (this.serviceTypesSelected.length == 0) {
				this.$root.showAlert(
					"Seleccione al menos un tipo de servicio",
					{
						variant: "warning"
					}
				);
				return false;
			}

			this.loading = true;
			let services = [];
			this.serviceTypesSelected.forEach(element => {
				services.push(element.value);
			});

			this.modelInfo.serviceTypes = services;
			this.modelInfo.startDate = this.parseDateTime(this.range.start);
			this.modelInfo.endDate = this.parseDateTime(this.range.end);
			this.modelInfo.status = this.status;

			if (rParams.method == "get") {
				rParams["params"] = this.modelInfo;
			} else {
				rParams["data"] = this.modelInfo;
			}

			this.$root.api
				.request(rParams)
				.then(res => {
					console.log("resquest");
					console.log(res);
					//validamos que sea una respuestas 200 o 2001 del lado del servidor
					if (res.status == 200 || res.status == 201) {
						if (res.data.error) {
							this.$root.showAlert(res.data.error, {
								variant: "warning"
							});
							return false;
						}

						this.$root.showAlert("OK!");
						if (res.data.id) this.loadModel(res.data.id);
						this.successCallback(res);

						if (this.modelId == -1) {
							this.range = this.setTimeDefault();
							this.ratePlansSelected = [];
							this.serviceTypesSelected = [];
							this.modelInfo.description = "";
							this.modelInfo.status = "active";
						}
					}
				})
				.catch(this.$root.handleRequestError)
				.then(() => {
					this.loading = false;
					//   this.errorForm = Utils.getErrorHTTP(error);
				});
		},
		loadRatePlansOpts() {
			this.$root.api.get(`/rate-plans/all`).then(res => {
				this.ratePlans = res.data;
			});
		},
		selectRatePlan(selected) {
			this.modelInfo.ratePlanId = selected.value;
			let ratePlanObj = this.ratePlans.find(
				rt => rt.id == selected.value
			);
			this.serviceTypes = ratePlanObj.services;
			this.serviceTypesSelected = [];

			this.childrenRatePlan = [];
			if (ratePlanObj.childrenRatePlan.length) {
				ratePlanObj.childrenRatePlan.forEach(element => {
					this.childrenRatePlan.push(
						`${element.id}: ${element.title}`
					);
				});
			}

			if (this.childrenRatePlan.length >= 10) {
				this.visible = false;
			} else {
				this.visible = true;
			}
		},
		parseDateTime(dateTime) {
			let day = ("0" + dateTime.getDate()).slice(-2);
			let month = ("0" + (dateTime.getMonth() + 1)).slice(-2);
			let year = dateTime.getFullYear();

			var hour = String(dateTime.getHours()).padStart(2, "0");
			var minutes = String(dateTime.getMinutes()).padStart(2, "0");
			var seconds = String(dateTime.getSeconds()).padStart(2, "0");

			var dateTimeString = `${year}-${month}-${day} ${hour}:${minutes}:${seconds}`;

			return dateTimeString;
		},
		setTimeDefault() {
			var today = new Date();
			var week = new Date();
			var start = new Date(
				`${today.getFullYear()}/${today.getMonth() +
					1}/${today.getDate()} 00:00:00`
			);
			var end = new Date(
				`${week.getFullYear()}/${week.getMonth() +
					1}/${week.getDate()} 23:59:59`
			);
			end = new Date(end.setDate(end.getDate() + 7));

			return { start, end };
		}
	},
	mounted() {
		this.loadRatePlansOpts();
	}
};
</script>
<style scoped>
.arrow {
	width: 16px;
}
</style>
